export default "__VITE_ASSET__ea762642__"